import { JoinProInfoPageController } from '@application/components';
import { JoinProInfoPageType } from '@presentation/pages';
import type { JoinProInfoProfilePageControllerProps } from './types';

export * from './types';

export const JoinProInfoProfilePageController = (props: JoinProInfoProfilePageControllerProps) => {
  const { type } = props;

  return <JoinProInfoPageController type={JoinProInfoPageType.PROFILE} proType={type} />;
};
